import React from "react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import FormField from "./FormField";
import { useSelector } from "react-redux";
import { Loader2 } from "lucide-react";

const VehicleInfoFields = ({
  formData,
  handleSelectChange,
  handleInputChange,
  errors,
  availableModels,
  isSubmitting,
  years
}) => {
  const { makes, modelLoading } = useSelector((state) => state.parts);

  return (
    <>
      <FormField id="year" label="Year" error={errors.year}>
        <Select
          onValueChange={(val) => handleSelectChange("year", val)}
          value={formData.year}
          name="year"
          disabled={isSubmitting}
        >
          <SelectTrigger id="year">
            <SelectValue placeholder="Select Year" />
          </SelectTrigger>
          <SelectContent>
            {years.map((y) => (
              <SelectItem key={y} value={y.toString()}>
                {y}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>

      <FormField id="make" label="Make" error={errors.make}>
        <Select
          onValueChange={(val) => handleSelectChange("make", val)}
          value={formData.make}
          name="make"
          disabled={isSubmitting}
        >
          <SelectTrigger id="make">
            <SelectValue placeholder="Select Make" />
          </SelectTrigger>
          <SelectContent>
            {makes?.map((make) => (
              <SelectItem key={make.id} value={make.name}>
                {make.name}
              </SelectItem>
            ))}
            <SelectItem value="Other">Other (Specify Below)</SelectItem>
          </SelectContent>
        </Select>
        {formData.make === "Other" && (
          <Input
            id="makeOther"
            name="makeOther"
            placeholder="Specify Make"
            value={formData.makeOther || ""}
            onChange={handleInputChange}
            className="mt-2"
            disabled={isSubmitting}
          />
        )}
      </FormField>

      <FormField
        id="model"
        label="Model"
        error={errors.model || errors.modelOther}
      >
        <Select
          onValueChange={(val) => handleSelectChange("model", val)}
          value={formData.model}
          name="model"
          disabled={!formData.make || isSubmitting || modelLoading}
        >
          <SelectTrigger id="model">
            {modelLoading ? (
              <div className="flex items-center">
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Loading models...
              </div>
            ) : (
              <SelectValue
                placeholder={
                  formData.make ? "Select Model" : "Select Make First"
                }
              />
            )}
          </SelectTrigger>
          <SelectContent>
            {availableModels?.map((model) => (
              <SelectItem key={model.id} value={model.name}>
                {model.name}
              </SelectItem>
            ))}
            {formData.make && (
              <SelectItem value="Other">Other (Specify Below)</SelectItem>
            )}
          </SelectContent>
        </Select>
        {formData.model === "Other" && (
          <Input
            id="modelOther"
            name="modelOther"
            placeholder="Specify Model"
            value={formData.modelOther}
            onChange={handleInputChange}
            className="mt-2"
            disabled={isSubmitting}
          />
        )}
      </FormField>
    </>
  );
};

export default VehicleInfoFields;
